/** Focused activities. Never alter saved learner work or completion rules. */
export const FOOD_DELIVERY_ROBOT_FLOW = {
  "fdr-prelude": [
    {
      "id": "fdr-prelude-1",
      "title": "Hear the delivery mystery",
      "purpose": "Watch/read the story",
      "blockIds": [
        "fdr-story-video",
        "fdr-first-risk",
        "fdr-swan-prelude",
        "fdr-prelude-gate"
      ]
    }
  ],
  "fdr-wonder": [
    {
      "id": "fdr-wonder-1",
      "title": "Choose a delivery goal",
      "purpose": "Make a testable prediction",
      "blockIds": [
        "fdr-problem",
        "fdr-criterion",
        "fdr-load-prediction",
        "fdr-swan-wonder",
        "fdr-wonder-gate"
      ]
    }
  ],
  "fdr-explore": [
    {
      "id": "fdr-explore-1",
      "title": "Inspect the kit",
      "purpose": "Recognize the real hardware",
      "blockIds": [
        "fdr-kit-story",
        "fdr-real-parts",
        "fdr-found-parts",
        "fdr-part-job",
        "fdr-swan-explore",
        "fdr-explore-gate"
      ]
    }
  ],
  "fdr-understand": [
    {
      "id": "fdr-understand-1",
      "title": "See the power path",
      "purpose": "Discover cause and effect",
      "blockIds": [
        "fdr-energy-question",
        "fdr-power-video",
        "fdr-switch-idea",
        "fdr-power-chain",
        "fdr-swan-understand",
        "fdr-understand-gate"
      ]
    }
  ],
  "fdr-apply": [
    {
      "id": "fdr-apply-1",
      "title": "Build the robot",
      "purpose": "Follow physical checks and 3D",
      "blockIds": [
        "fdr-assemble-safety",
        "fdr-assembly-pwo",
        "fdr-build-check"
      ]
    },
    {
      "id": "fdr-apply-2",
      "title": "First movement",
      "purpose": "Observe what happened",
      "blockIds": [
        "fdr-motion-predict",
        "fdr-motion-test",
        "fdr-master-teacher-diagnostic",
        "fdr-swan-apply",
        "fdr-apply-gate"
      ]
    }
  ],
  "fdr-test-improve": [
    {
      "id": "fdr-test-1",
      "title": "Delivery Trial 1",
      "purpose": "Collect honest evidence before explanation",
      "blockIds": [
        "fdr-motion-recall",
        "fdr-delivery-test1"
      ]
    },
    {
      "id": "fdr-test-2",
      "title": "Explain and plan",
      "purpose": "Watch the video after your trial",
      "blockIds": [
        "fdr-cargo-video",
        "fdr-change-plan",
        "fdr-change-predict"
      ]
    },
    {
      "id": "fdr-test-3",
      "title": "Delivery Trial 2",
      "purpose": "Run a fair comparison or safely stop",
      "blockIds": [
        "fdr-delivery-test2",
        "fdr-swan-improve",
        "fdr-test-improve-gate"
      ]
    }
  ],
  "fdr-explain": [
    {
      "id": "fdr-explain-1",
      "title": "Explain what happened",
      "purpose": "Connect mechanism and physical evidence",
      "blockIds": [
        "fdr-compare-trials",
        "fdr-mechanism-chain",
        "fdr-evidence-claim",
        "fdr-swan-explain",
        "fdr-explain-gate"
      ]
    }
  ],
  "fdr-reflect": [
    {
      "id": "fdr-reflect-1",
      "title": "Look back",
      "purpose": "Compare prediction with observation",
      "blockIds": [
        "fdr-original-risk",
        "fdr-thinking-change",
        "fdr-key-learning",
        "fdr-swan-reflect",
        "fdr-reflect-gate"
      ]
    }
  ],
  "fdr-grow": [
    {
      "id": "fdr-grow-1",
      "title": "Invent another challenge",
      "purpose": "Transfer learning to a new problem",
      "blockIds": [
        "fdr-new-delivery",
        "fdr-new-plan",
        "fdr-share",
        "fdr-swan-grow",
        "fdr-grow-gate"
      ]
    }
  ]
};
